export const ANIMATION_CDN_ORIGIN = "https://static.readdy.ai";
export const ANIMATION_META_PATH = "/anim/latest/meta.json";
export const ANIMATION_FALLBACK_ASSETS = {
  js: "/anim/latest/dist/full.js",
  css: "/anim/latest/dist/full.css",
} as const;

export const RUNTIME_CSS_ID = "readdy-anim-runtime-css";
export const RUNTIME_JS_ID = "readdy-anim-runtime-js";
export const RESULT_MESSAGE_TYPE = "preview-animation:result";
